import { render, staticRenderFns } from "./ActionCard.vue?vue&type=template&id=33225b49&scoped=true"
import script from "./ActionCard.vue?vue&type=script&lang=js"
export * from "./ActionCard.vue?vue&type=script&lang=js"
import style0 from "./ActionCard.vue?vue&type=style&index=0&id=33225b49&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33225b49",
  null
  
)

export default component.exports